import React from 'react';
import PropTypes from 'prop-types';

import Styles from './ConfigsListItem.styles';

const ConfigsListItemWrapper = ({
  children,
  onClick,
}) => (
  <div
    className={Styles.default}
    onClick={onClick}
    role="presentation"
  >
    {children}
  </div>
);

ConfigsListItemWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ConfigsListItemWrapper;
